import { Link } from "@opensea/next-ui-kit"
import { TextBody } from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import { PRIVACY_POLICY_URL } from "@/constants/constants"

export function PageFooterPrivacyPolicy() {
  const t = useTranslations("PageFooterPrivacyPolicy")

  return (
    <Link className="-mt-[4px]" href={PRIVACY_POLICY_URL} variant="unstyled">
      <TextBody color="text-secondary" size="xs">
        {t("privacyPolicy")}
      </TextBody>
    </Link>
  )
}
